import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';
import { validationEmail } from 'core/validators';
import router from 'src/router';
import * as api from 'core/api';
import { G2S } from 'core/g2s';
import * as auth from 'core/auth';
import moment from 'moment';
import * as utils from 'core/utils';
import { initAnalytics, sendAnalyticsEvent } from '../../../../../node_modules_local/analytics/index.js';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

type SupportNewComponentState = 'form' | 'success';

export interface SupportNewComponentModel {
    state: SupportNewComponentState;
    submitted: boolean;
    error: string;
    category: string | null;
    clarification: string | null;
    subCategory: string | null;
    description: string | null;
    orderNumber: string;
    exchangeDesiredDate: string | null;
    departureDate: string | null,
    email: string;
    flightServices: any[] | null;
    aviasalesUid: string | null;
    megoUid: string | null;

    orderNumberErrorMessage: string | null;
    emailErrorMessage: string | null;
    exchangeDesiredDateErrorMessage: string | null;
    departureDateErrorMessage: string | null,
    descriptionErrorMessage: string | null;

    maxOrderNumberLegth: number;
}

function customRequiredOrderNumber(value, parentVm) {
    console.log('customRequiredOrderNumber')
    console.log(parentVm.category);
    if (value.length === 0) {
        if (
            parentVm.category === 'itinerary' ||
            parentVm.category === 'error' ||
            parentVm.category === 'bonuses' ||
            parentVm.category === 'other'
        ) {
            return true;
        } else {
            return false;
        }
    }
    return true;
}

function validateOrderNumber(value, parentVm) {
    if (value.length === 0) {
        return true;
    }
    return value.length === parentVm.maxOrderNumberLegth ? true : false;
}

function validateDayMonthDepartureDate(value, parentVm) {
    if (parentVm.category !== 'itinerary' || !value) {
        return true;
    }
    return moment(value, 'DD.MM').isValid();
}

function validateDayMonthExchangeDesiredDate(value, parentVm) {
    if (parentVm.category !== 'flight_change') {
        return true;
    }
    return moment(value, 'DD.MM').isValid();
}

function customRequiredExchangeDesiredDate(value, parentVm) {
    console.log('customRequiredExchangeDesiredDate');
    console.log(parentVm.category);
    if (parentVm.category !== 'flight_change') {
        return true;
    }

    return value.length > 0 ? true : false;
}

export function customMaxLengthDepartureDate(value: string, parentVm: any): boolean {
    if (parentVm.category === 'itinerary' && value.length > 0) {
        return value.length === 10 ? true : false;
    } else {
        return true;
    }
}

export function customMaxLengthExchangeDesiredDate(value: string, parentVm: any): boolean {
    if (parentVm.category === 'flight_change' && value.length > 0) {
        return value.length === 10 ? true : false;
    } else {
        return true;
    }
}

function validateYearDepartureDate(value, parentVm) {
    if (parentVm.category !== 'itinerary' || !value) {
        return true;
    }
    if (value.length === 10) {
        const currentYear = moment().year()
        const nextYear = currentYear + 1;
        const enteredDate = Number(moment(value, 'DD.MM.YYYY').format('YYYY'));
        if (
            moment(value, 'DD.MM.YYYY').isSameOrAfter(moment(), 'day') &&
            enteredDate <= nextYear
        ) {
            return true;
        }
    }
    return false;
}

function validateYearExchangeDesiredDate(value, parentVm) {
    if (parentVm.category !== 'flight_change') {
        return true;
    }
    if (value.length === 10) {
        const currentYear = moment().year()
        const nextYear = currentYear + 1;
        const enteredDate = Number(moment(value, 'DD.MM.YYYY').format('YYYY'));
        if (
            moment(value, 'DD.MM.YYYY').isSameOrAfter(moment(), 'day') &&
            enteredDate <= nextYear
        ) {
            return true;
        }
    }

    return false;
}

@WithRender
@Component({
    validations: {
        model: {
            description: {required},
            orderNumber: {customRequiredOrderNumber, validateOrderNumber},
            email: {required, email},
            exchangeDesiredDate: {
                customRequiredExchangeDesiredDate,
                customMaxLengthExchangeDesiredDate,
                validateDayMonthExchangeDesiredDate,
                validateYearExchangeDesiredDate
            },
            departureDate: {customMaxLengthDepartureDate, validateDayMonthDepartureDate, validateYearDepartureDate},
        }
    }
})
export default class SupportNewComponent extends Vue {
    $auth: auth.AuthService; // Injected in G2S.init
    $ga: utils.GoogleAnalyticsService; // Injected in G2S.init
    gaParams: utils.GoogleAnalyticsParams = new utils.GoogleAnalyticsParams();

    @Prop()
    orderNumber: string;

    model: SupportNewComponentModel = {
        state: 'form',
        submitted: false,
        error: '',
        category: '',
        clarification: '',
        subCategory: '',
        description: '',
        orderNumber: '',
        email: '',
        exchangeDesiredDate: '',
        departureDate: '',
        flightServices: [],
        aviasalesUid: null,
        megoUid: null,

        orderNumberErrorMessage: '',
        emailErrorMessage: '',
        exchangeDesiredDateErrorMessage: '',
        departureDateErrorMessage: '',
        descriptionErrorMessage: '',

        maxOrderNumberLegth: 7,
    }

    refundInfo: api.RefundInfo = {
        clientText: '',
        headerText: '',
        youPaidText: '',
        weWillRefundText: '',
        termText: '',
        buttonAcceptText: '',
        buttonRejectText: '',
        buttonWriteManuallyText: '',
        refundSum: 0,
        paidSum: 0,
        refundSumCurrency: ''
    };

    reservationData: any | null = null;
    cachedReservationData: any | null = null;

    isVisibleAutovoid = false;
    autovoidTimeout: number | null = null;
    autovoidLabel = {
        adviseText: '',
        accountText: ''
    };

    categoryOptions: utils.SupportCategoryOption[] = [];
    refundOptions: utils.SupportCategoryOption[] = [];
    changeTicketOptions: utils.SupportCategoryOption[] = [];
    changeInfoOptions: utils.SupportCategoryOption[] = [];
    additionalServiceOptions: utils.SupportCategoryOption[] = [];

    acceptedFileTypes = [
        'text/plain',
        'image/jpeg',
        'image/pjpeg',
        'image/png',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'application/pdf'
    ];

    selectedFiles = [];

    dateMask: string | null = null;

    tooltipActivator: string | null = null;
    tooltipText: string | null = null;
    tooltipVisible: boolean = false;
    tooltipTimeout: number | null = null;

    // fullPassedCategories = [
    //     'baggage',
    //     'kid_ticket',
    //     'pet_ticket',
    //     'error',
    //     'bonuses',
    //     'other',
    // ];
    clarificationFieldConditionValues = [
        'flight_change',
        'flight_refund',
        'changes',
        'add_services',
    ]

    refundAlgorytmResult: number | null = null;
    changeAlgorytmResult: number | null = null;
    cancelAlgorytmResult: number | null = null;
    additionalSertviceAlgorytmResult: number | null = null;

    checkedOrderNumber: string | null = null;
    categoryWasSelected: boolean = false;

    defaultAdditionalSerives: any = [
        {
            isSelected: false,
            russianName: 'Выбор места',
            englishName: 'Seat Selection',
            internalName: 'Выбор места',
        },
        {
            isSelected: false,
            russianName: 'Сопровождение',
            englishName: 'Assistance',
            internalName: 'Сопровождение'
        },
        {
            isSelected: false,
            russianName: 'Питание',
            englishName: 'Meals',
            internalName: 'Питание'
        },
        {
            isSelected: false,
            russianName: 'Другое',
            englishName: 'Other',
            internalName: 'Другое'
        },
    ]

    get clarificationOptions(): utils.SupportCategoryOption[] {
        switch (this.model.category) {
            case 'flight_refund':
                return this.refundOptions;
            case 'flight_change':
                return this.changeTicketOptions;
            case 'changes':
                return this.changeInfoOptions;
            case 'add_services':
                return this.additionalServiceOptions;
            default:
                return [];
        }
    }

    onClarificationChange() {
        for (let i = this.refundOptions?.length - 1; i >= 0; i--) {
            if (this.refundOptions[i].value === null) {
                this.refundOptions.splice(i, 1);
            }
        }
        for (let i = this.changeTicketOptions?.length - 1; i >= 0; i--) {
            if (this.changeTicketOptions[i].value === null) {
                this.changeTicketOptions.splice(i, 1);
            }
        }
        for (let i = this.changeInfoOptions?.length - 1; i >= 0; i--) {
            if (this.changeInfoOptions[i].value === null) {
                this.changeInfoOptions.splice(i, 1);
            }
        }
        for (let i = this.additionalServiceOptions?.length - 1; i >= 0; i--) {
            if (this.additionalServiceOptions[i].value === null) {
                this.additionalServiceOptions.splice(i, 1);
            }
        }
        if (
            this.model.orderNumber.length === this.model.maxOrderNumberLegth &&
            this.model.orderNumber == this.checkedOrderNumber
        ) {
            return;
        }
        this.resetValidations();

        this.reservationData = null;
        this.refundAlgorytmResult = null;
        this.changeAlgorytmResult = null;
        this.cancelAlgorytmResult = null;
        this.additionalSertviceAlgorytmResult = null;
        this.tryCheckReservationByOrderNumber();
    }

    get isOrderNumberRequired() {
        if (
            this.model.category === 'itinerary' ||
            this.model.category === 'error' ||
            this.model.category === 'bonuses' ||
            this.model.category === 'other'
        ) {
            return false;
        }
        return true;
    }

    get activeCategoryOption(): string | null { // topic
        const item = this.categoryOptions.find(item => item.value === this.model.category);
        return item ? item.label : null;
    }

    get activeClarificationChangeInfoOption(): string | null { // change
        const item = this.changeInfoOptions.find(item => item.value === this.model.clarification);
        return item ? item.label : null;
    }

    get activeClarificationAdditionalServiceOption(): string | null { // subtopic
        const item = this.additionalServiceOptions.find(item => item.value === this.model.clarification);
        return item ? item.label : null;
    }

    get activeClarificationRefundOptionsOption(): string | null { // reason
        const item = this.refundOptions.find(item => item.value === this.model.clarification);
        return item ? item.label : null;
    }

    get isClarificationVisible() {
        return this.clarificationFieldConditionValues.includes(this.model.category!)
    }

    get isOrderNumberVisible() {
        return !!this.model.category
    }

    get isEmailVisible() {
        if (
            this.model.category === 'itinerary' ||
            this.model.category === 'baggage' ||
            this.model.category === 'kid_ticket' ||
            this.model.category === 'pet_ticket' ||
            this.model.category === 'error' ||
            this.model.category === 'timetable' ||
            this.model.category === 'bonuses' ||
            this.model.category === 'other'
        ) {
            return true;
        }
        if (this.model.category === 'flight_refund') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.refundAlgorytmResult !== null &&
                this.refundAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'flight_change') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.changeAlgorytmResult !== null &&
                this.changeAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'cancel_same_day') {
            if (
                this.cancelAlgorytmResult !== null &&
                this.cancelAlgorytmResult !== 3
            ) {
                return true;
            }
        }

        if (this.model.category === 'changes') {
            if (this.model.clarification?.length) {
                return true;
            }
        }

        if (this.model.category === 'add_services') {
            if (
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_add'
            ) {
                return true;
            }
            if (
                this.additionalSertviceAlgorytmResult === 1 &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
            if (
                this.reservationData !== null &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
        }

        return false;
    }

    get isDepartureDateVisible() {
        if (this.model.category === 'itinerary') {
            return true;
        }

        return false;
    }

    get isDesiredDateVisible() {
        // model.category === 'flight_change' && $g2s.locale === 'ru'
        if (this.model.category === 'flight_change') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.changeAlgorytmResult !== null &&
                this.changeAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        return false;
    }

    get isServicesVisible() {
        if (this.model.category === 'add_services') {
            if (
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_add'
            ) {
                this.servicesOptions();
                return true;
            }
            if (
                this.additionalSertviceAlgorytmResult === 1
            ) {
                return false;
            }
            if (
                this.reservationData !== null &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                this.servicesOptions();
                return true;
            }
        }

        return false;
    }

    get isUploadVisible() {
        if (
            this.model.category === 'itinerary' ||
            this.model.category === 'baggage' ||
            this.model.category === 'kid_ticket' ||
            this.model.category === 'pet_ticket' ||
            this.model.category === 'error' ||
            this.model.category === 'timetable' ||
            this.model.category === 'bonuses' ||
            this.model.category === 'other'
        ) {
            return true;
        }
        if (this.model.category === 'flight_refund') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.refundAlgorytmResult !== null &&
                this.refundAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'flight_change') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.changeAlgorytmResult !== null &&
                this.changeAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'cancel_same_day') {
            if (
                this.cancelAlgorytmResult !== null &&
                this.cancelAlgorytmResult !== 3
            ) {
                return true;
            }
        }

        if (this.model.category === 'changes') {
            if (this.model.clarification?.length) {
                return true;
            }
        }

        if (this.model.category === 'add_services') {
            if (

                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_add'
            ) {
                return true;
            }
            if (
                this.additionalSertviceAlgorytmResult === 1 &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
            if (
                this.reservationData !== null &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
        }

        return false;
    }

    get isDescriptionVisible() {
        if (
            this.model.category === 'itinerary' ||
            this.model.category === 'baggage' ||
            this.model.category === 'kid_ticket' ||
            this.model.category === 'pet_ticket' ||
            this.model.category === 'error' ||
            this.model.category === 'timetable' ||
            this.model.category === 'bonuses' ||
            this.model.category === 'other'
        ) {
            return true;
        }
        if (this.model.category === 'flight_refund') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.refundAlgorytmResult !== null &&
                this.refundAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'flight_change') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.changeAlgorytmResult !== null &&
                this.changeAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'cancel_same_day') {
            if (
                this.cancelAlgorytmResult !== null &&
                this.cancelAlgorytmResult !== 3
            ) {
                return true;
            }
        }

        if (this.model.category === 'changes') {
            if (this.model.clarification?.length) {
                return true;
            }
        }

        if (this.model.category === 'add_services') {
            if (

                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_add'
            ) {
                return true;
            }
            if (
                this.additionalSertviceAlgorytmResult === 1 &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
            if (
                this.reservationData !== null &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
        }

        return false;
    }

    get isSendVisible() {
        if (
            this.model.category === 'itinerary' ||
            this.model.category === 'baggage' ||
            this.model.category === 'kid_ticket' ||
            this.model.category === 'pet_ticket' ||
            this.model.category === 'error' ||
            this.model.category === 'timetable' ||
            this.model.category === 'bonuses' ||
            this.model.category === 'other'
        ) {
            return true;
        }
        if (this.model.category === 'flight_refund') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.refundAlgorytmResult !== null &&
                this.refundAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'flight_change') {
            if (
                this.model.clarification?.length &&
                this.model.clarification !== 'clarification_personal_reasons'
            ) {
                return true;
            }
            if (
                this.model.clarification?.length &&
                this.changeAlgorytmResult !== null &&
                this.changeAlgorytmResult !== 4
            ) {
                return true;
            }
        }

        if (this.model.category === 'cancel_same_day') {
            if (
                this.cancelAlgorytmResult !== null &&
                this.cancelAlgorytmResult !== 3
            ) {
                return true;
            }
        }

        if (this.model.category === 'changes') {
            if (this.model.clarification?.length) {
                return true;
            }
        }

        if (this.model.category === 'add_services') {
            if (

                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_add'
            ) {
                return true;
            }
            if (
                this.additionalSertviceAlgorytmResult === 1 &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
            if (
                this.reservationData !== null &&
                this.model.clarification?.length &&
                this.model.clarification === 'clarification_service_cancel'
            ) {
                return true;
            }
        }

        return false;
    }

    get clarificationLabel() {
        switch (this.model.category) {
            case 'flight_refund':
                return i18next.t('label_suport_request_choose_reason');
            case 'flight_change':
                return i18next.t('label_suport_request_choose_reason');
            case 'changes':
                return i18next.t('label_suport_request_choose_changes');

            default:
                return i18next.t('label_suport_request_clarification');
        }
    }

    servicesOptions() {
        if (this.model.clarification === 'clarification_service_add') {
            this.model.flightServices = this.defaultAdditionalSerives;
            return;
        } else {
            switch (this.additionalSertviceAlgorytmResult) {
                case 2:
                    if (
                        this.reservationData?.reservationServices !== null
                    ) {
                        const notPartOfPackageServices = this.reservationData.reservationServices.filter(service => service.isPartOfPackage === false)
                        this.model.flightServices = [...this.reservationData.reservationServicePackages, ...notPartOfPackageServices, ...this.defaultAdditionalSerives];
                        return;
                    }
                    this.model.flightServices = [...this.reservationData.reservationServicePackages, ...this.defaultAdditionalSerives];
                    return;
                case 3:
                    this.model.flightServices = [...this.reservationData.reservationServices, ...this.defaultAdditionalSerives];
                    return;
                case 4:
                    this.model.flightServices = this.defaultAdditionalSerives;
                    return;
                default:
                    break;
            }
        }
    }

    orderNumberTooltip(event) {
        if (event.key.length === 1 && !event.metaKey && !event.ctrlKey) {
            if (
                /[^0-9]/gi.test(event.key) ||
                this.model.orderNumber.length === this.model.maxOrderNumberLegth ||
                /^[a-zA-Z]$/.test(event.key)
            ) {
                this.showTooltip(
                    (<any>this.$refs).orderNumber.$el,
                    // label TODO
                    i18next.t('error_optimal_length', {i: this.model.maxOrderNumberLegth}),
                );
            }
        }
    }

    mounted() {
        // if (G2S.config.theme === 'aviasales') {

        // }

        this.loadModel();
        initAnalytics({
            trackerId: 'aviasales_helios',
            auid: this.model.aviasalesUid || undefined,
            // settings: {
            //     debug: true,
            // },
        })
        // temporary comment
        // this.model.maxOrderNumberLegth = G2S.config.environment !== 'Production' ? 7 : 7;
        this.dateMask = moment().localeData().longDateFormat('L').replace(/(D|M|Y)/gi, '#');
        this.tryCheckReservationByOrderNumber();

        let dataPrecompleted: any = {};

        dataPrecompleted = {
            email: this.model.email || undefined,
            num_order: this.model.orderNumber || undefined,
            departure_date: this.model.departureDate || undefined,
        };
        
        this.sendAviasalesAnalyticsEvent({
            label: 'ota_feedback_form',
            action: 'showed',
            source: 'guide',
            data_precompleted: dataPrecompleted,
        });
    }

    previousWarningRefs: any = null;

    updated() {
        this.checkWarningVisability();
    }
    checkWarningVisability() {
        const currentWarningRefs = [
            this.$refs.baggageWarning,
            this.$refs.itineraryWarning,
            this.$refs.errorWarning,
            this.$refs.bonusesWarning,
            this.$refs.timetableWarning,
            this.$refs.otherWarning,
            this.$refs.ticketRefundSecondWarning,
            this.$refs.ticketRefundThirdWarning,
            this.$refs.ticketExchangeSecondWarning,
            this.$refs.ticketExchangeThirdWarning,
            this.$refs.ticketRefundFourthWarning,
            this.$refs.ticketRefundFifthWarning,
            this.$refs.ticketRefundSixthWarning,
            this.$refs.ticketRefundSeventhWarning,
            this.$refs.ticketRefundEighthWarning,
            this.$refs.ticketExchangeFourthWarning,
            this.$refs.cancellationSecondWarning,
            this.$refs.kidTicketWarning,
            this.$refs.petTicketWarning,
            this.$refs.serviceWarning,
            this.$refs.serviceSecondWarning,
            this.$refs.serviceThirdWarning,
            this.$refs.serviceFourthWarning,
            this.$refs.ticketRefundWarning,
            this.$refs.ticketExchangeWarning,
            this.$refs.cancellationWarning,
            this.$refs.changesWarning,
            this.$refs.changesSecondWarning,
            this.$refs.changesThirdWarning,
            this.$refs.servicesWarning
        ];

        const hasChanged = this.previousWarningRefs === null || !this.previousWarningRefs.every((ref, index) => ref === currentWarningRefs[index]);
        const atLeastOneHasValue = currentWarningRefs.some(ref => ref !== undefined && ref !== null);

        if (hasChanged && atLeastOneHasValue) {
            const dataPrecompleted = {
                email: this.model.email || undefined,
                num_order: this.model.orderNumber || undefined,
                departure_date: this.model.departureDate || undefined,
                change: this.activeClarificationChangeInfoOption || undefined,
                description: this.model.description || undefined,
                reason: this.activeClarificationRefundOptionsOption || undefined,
                subtopic: this.activeClarificationAdditionalServiceOption || undefined,
                topic: this.activeCategoryOption || undefined,
                with_attachment: this.selectedFiles.length || undefined,
            }
            this.sendAviasalesAnalyticsEvent({
                label: 'ota_feedback_form_warning',
                action: 'showed',
                data_precompleted: dataPrecompleted,

                topic: this.activeCategoryOption || '',
                is_submit_button: this.isSendVisible.toString(),
            });
        }
    
        this.previousWarningRefs = currentWarningRefs;    
    }

    showTest() {
        console.log((<any>this).$refs.ticketRefundSecondWarning);
    }
    get test() {
        return (<any>this).$refs.ticketRefundSecondWarning == undefined;
    }

    handleRefChange() {
        console.log('got');
    }

    async sendAviasalesAnalyticsEvent(eventDetails) {
        const {
            label,
            action,
            error_type = null,
            source = null,
            data_precompleted = null,
            data_completed = null,
            message = null,
            warning_type = null,
            is_submit_button = null,
        } = eventDetails;

        let EventData: any = {
            category: 'support',
            label: label,
            action: action,
            service: 'support',
            mego_uid: this.model.megoUid || undefined,
            message: message || undefined,
            warning_type: warning_type || undefined,
            platform: 'web-desktop',
            is_submit_button: is_submit_button || undefined,
        };

        sendAnalyticsEvent({
            // @ts-ignore
            ...EventData,
        }, {
            // @ts-ignore
            data_precompleted: data_precompleted || undefined,
            data_completed: data_completed || undefined,
            error_type: error_type || undefined,
            // @ts-ignore
            source: source || undefined,
        });
    }


    loadModel() {
        this.model.state = 'form';
        this.model.submitted = false;
        this.loadSubCategories();
        this.categoryOptions = utils.Support.categoryOptions();
        // this.baggageAdditionalOptions = utils.Support.baggageOptions();

        this.$auth.getSupportText(G2S.config.locale).then(
            (result) => {
                this.autovoidLabel = {
                    adviseText: result.adviseText,
                    accountText: result.accountText
                };
            },
            (error) => {
                console.log(error);
            }
        );

        if ((<any>this).$route.query.t) {
            this.model.category = (<any>this).$route.query.t;
        }

        if (this.orderNumber) {
            this.model.orderNumber = this.orderNumber;
            (<any>this).$v.model.orderNumber.$touch();
            this.validateOrderNumber();
        } else if ((<any>this).$route.query.g) {
            new api.ReservationService().getReservationStatus((<any>this).$route.query.g, false, false).then(
                (result: api.GetReservationStatusResult) => {
                    this.model.orderNumber = result.reservationInfo.reservationNumber;
                }
            );
            (<any>this).$v.model.orderNumber.$touch();
            this.validateOrderNumber();
        }

        if ((<any>this).$route.query.email) {
            this.model.email = (<any>this).$route.query.email;
            (<any>this).$v.model.email.$touch();
            this.validateEmail();
        } else if (this.$auth.authenticated) {
            this.$auth.getCurrentUser().then(
                (result: api.User) => {
                    if (result.email) {
                        this.model.email = result.email;
                    }
                }
            );
            (<any>this).$v.model.email.$touch();
            this.validateEmail();
        }

        if ((<any>this).$route.query.description) {
            this.model.description = (<any>this).$route.query.description;
        }

        const cl = (<any>this).$route.query.cl;

        if (cl && this.model.category) {
            const clarificationLocal = this.clarificationOptions.find(
                с => с.value === cl,
            );
            if (clarificationLocal) {
                this.model.clarification = clarificationLocal.value;
            }
        }

        if ((<any>this).$route.query.uid) {
            this.model.aviasalesUid = (<any>this).$route.query.uid;
            console.log(this.model.aviasalesUid);
        }

        const uidMego = utils.Cookies.uidGet();

        if (uidMego) {
            this.model.megoUid = uidMego;
        }
    }

    @Watch('reservationData')
    onreservationDataChanged() {
        if (this.model.orderNumber.length !== 0) {
            this.updateAlgorytmsResults();
        }
    }

    @Watch('model.orderNumber')
    onOrderNumberChange() {
        if (this.model.orderNumber?.length === 0) {
            this.checkedOrderNumber = null;
        }
        this.reservationData = null;
        this.refundAlgorytmResult = null;
        this.changeAlgorytmResult = null;
        this.cancelAlgorytmResult = null;
        this.additionalSertviceAlgorytmResult = null;
    }

    @Watch('model.category')
    onChangeCategory() {
        this.handlePropertiesChanges();
    }

    @Watch('model.clarification')
    onChangeClarification() {
        this.handlePropertiesChanges();
    }

    @Watch('refundAlgorytmResult')
    onRefundAlgorithmResultChange() {
        this.handlePropertiesChanges();
    }

    @Watch('changeAlgorytmResult')
    onChangeAlgorithmResultChange() {
        this.handlePropertiesChanges();   
    }

    @Watch('cancelAlgorytmResult')
    onCancelAlgorithmResultChange() {
       this.handlePropertiesChanges();
    }

    cashForEvent: any = null;

    handlePropertiesChanges() {
        const currentEventData = [
            this.model.category,
            this.model.clarification,
            this.refundAlgorytmResult,
            this.changeAlgorytmResult,
            this.cancelAlgorytmResult,
        ]
        const hasChanged = this.cashForEvent === null || !this.cashForEvent.every((ref, index) => ref === currentEventData[index]);
        if (!hasChanged) return;
        this.cashForEvent = currentEventData;
        const isPersonalReasons = this.model.clarification === 'clarification_personal_reasons';
        const refundCondition =
            this.model.category === 'flight_refund' &&
            isPersonalReasons &&
            this.refundAlgorytmResult !== null &&
            this.refundAlgorytmResult == 4;
        const changeCondition =
            this.model.category === 'flight_change' &&
            isPersonalReasons &&
            this.changeAlgorytmResult !== null &&
            this.changeAlgorytmResult == 4;
        const cancelCondition =
            this.model.category === 'cancel_same_day' &&
            this.cancelAlgorytmResult !== null &&
            this.cancelAlgorytmResult == 3;
        console.log(this.model.category);
        console.log(isPersonalReasons)
        console.log(refundCondition, cancelCondition, cancelCondition);
        console.log(this.refundAlgorytmResult, this.changeAlgorytmResult, this.refundAlgorytmResult)
        if (
            (refundCondition || changeCondition || cancelCondition) &&
            (this.refundAlgorytmResult ||
                this.changeAlgorytmResult ||
                this.cancelAlgorytmResult)
        ) {
            this.sendWarningWhenSendBtnNotVisible(refundCondition, changeCondition, cancelCondition);
        }
    }

    sendWarningWhenSendBtnNotVisible(isRefund, isChange, isCancel) {
        let message = '';
        if (isRefund) {
            message =    
                i18next.t('label_support_hint_flight_refund_twenty_fourth') +
                i18next.t('label_support_hint_flight_refund_twenty_fifth') +
                i18next.t('label_support_hint_flight_refund_twenty_sixth');
        }
        if (isChange) {
            message =
                i18next.t('label_support_hint_flight_change_twelfth') +
                i18next.t('label_support_hint_flight_change_thirteenth') +
                i18next.t('label_support_hint_flight_change_fourteenth');
        }
        if (isCancel) {
            message =
                i18next.t('label_support_hint_cancel_some_day_third') +
                i18next.t('label_support_hint_cancel_some_day_fourth');
        }

        if (message.length) {
            const dataPrecompleted = {
                email: this.model.email || undefined,
                num_order: this.model.orderNumber || undefined,
                departure_date: this.model.departureDate || undefined,
                change: this.activeClarificationChangeInfoOption || undefined,
                description: this.model.description || undefined,
                reason: this.activeClarificationRefundOptionsOption || undefined,
                subtopic: this.activeClarificationAdditionalServiceOption || undefined,
                topic: this.activeCategoryOption || undefined,
                with_attachment: this.selectedFiles.length || undefined,
            };
            this.sendAviasalesAnalyticsEvent({
                label: 'ota_feedback_form_send',
                action: 'showed',
                data_precompleted: dataPrecompleted,
                warning_type: message,
            });
        }
    }

    updateAlgorytmsResults() {
        this.refundAlgorytm();
        this.changeAlgorytm();
        this.cancelAlgorytm();
        this.additionalSertviceAlgorytm();
        console.log('refundAlgorytmResult' + this.refundAlgorytmResult)
        console.log('changeAlgorytmResult' + this.changeAlgorytmResult)
        console.log('cancelAlgorytmResult' + this.cancelAlgorytmResult)
        console.log('additionalSertviceAlgorytmResult' + this.additionalSertviceAlgorytmResult)
    }

    loadSubCategories() {
        this.refundOptions = utils.Support.refundOptions();
        this.changeTicketOptions = utils.Support.changeTicketOptions();
        this.changeInfoOptions = utils.Support.changeInfoOptions();
        this.additionalServiceOptions = utils.Support.additionalServiceOptions();
    }

    // resetForm() {
    //     this.model.email = '';
    //     this.model.clarification = '';
    //     this.model.orderNumber = '';
    //     this.model.exchangeDesiredDate = '';
    //     this.model.description = '';
    // }

    refundAlgorytm() {
        if (!this.reservationData) {
            this.refundAlgorytmResult = 1;
            return;
        }
        if (!this.reservationData.notSmartEconomFlightReservations) {
            this.refundAlgorytmResult = 2;
            return;
        }
        if (!this.reservationData.nonRefundableFlightReservations) {
            this.refundAlgorytmResult = 3;
            return;
        }
        if (this.reservationData.reservationServices === null) {
            this.refundAlgorytmResult = 4;
            return;
        }
        if (
            this.reservationData.reservationServices !== null &&
            !this.reservationData.reservationServices
                .some(e => e.russianName === 'Возврат без потерь' || [15, 66, 86, 90].includes(e.id))
        ) {
            this.refundAlgorytmResult = 4;
            return;
        }

        this.refundAlgorytmResult = 5;
    }

    changeAlgorytm() {
        if (!this.reservationData) {
            this.changeAlgorytmResult = 1;
            return;
        }
        if (!this.reservationData.notSmartEconomFlightReservations) {
            this.changeAlgorytmResult = 2;
            return;
        }
        if (!this.reservationData.unexchangeableFlightReservations) {
            this.changeAlgorytmResult = 3;
            return;
        }

        this.changeAlgorytmResult = 4;
    }

    cancelAlgorytm() {
        if (!this.reservationData) {
            this.cancelAlgorytmResult = 1;
            return;
        }
        if (this.reservationData.notCurrentDateReservationFlightReservations) {
            this.cancelAlgorytmResult = 3;
            return;
        } else if (this.reservationData.charterLowCostFlightReservations) {
            this.cancelAlgorytmResult = 3;
            return;
        } else {
            this.cancelAlgorytmResult = 2;
            return;
        }
    }

    additionalSertviceAlgorytm() {
        if (!this.reservationData) {
            this.additionalSertviceAlgorytmResult = 1;
            return;
        }
        if (this.reservationData.reservationServicePackages !== null) {
            this.additionalSertviceAlgorytmResult = 2;
            return;
        }
        if (this.reservationData.reservationServices !== null) {
            this.additionalSertviceAlgorytmResult = 3;
            return;
        }

        this.additionalSertviceAlgorytmResult = 4;
    }

    getAcceptedFileTypes(): string {
        return this.acceptedFileTypes.join(',');
    }

    getDescriptionPlaceholder(): string | null {
        switch (this.model.category) {
            case 'flight_change':
                return i18next.t('label_support_request_description_flight_change');
            case 'flight_refund':
                return i18next.t('label_support_request_description_flight_refund');
            case 'cancel_same_day':
                return i18next.t('label_support_request_description_cancel_same_day');
            case 'baggage':
                return i18next.t('label_support_request_description_baggage');
            case 'changes':
                return i18next.t('label_support_request_description_changes');
            case 'add_services':
                return i18next.t('label_support_request_description_add_services');
            case 'error':
                return i18next.t('label_support_request_description_error');
            default:
                return null;
        }
    }

    changeOrderNumber() {
        if ((<any>this).$v.model.orderNumber.$error) {
            (<any>this).$v.model.orderNumber.$touch();
            this.validateOrderNumber();
        }
        if (this.model.orderNumber.length === 0) {
            (<any>this).$v.model.orderNumber.$reset();
        }
        this.model.orderNumber = utils.String.normalizeNumber(
            this.model.orderNumber
        );

        this.checkVisibleAutovoid();

        // Hack to render new value
        (<any>this.$refs).orderNumber.lazyValue = this.model.orderNumber;

        this.tryCheckReservationByOrderNumber();
    }

    tryCheckReservationByOrderNumber() {
        if (!this.model.orderNumber.length) return;
        if (this.model.orderNumber == this.checkedOrderNumber) {
            this.reservationData = this.cachedReservationData;
            return;
        }
        if (
            this.model.orderNumber.length >= 6 &&
            this.model.orderNumber.length <= 7 &&
            this.model.orderNumber !== this.checkedOrderNumber
        ) {
            if (
                this.model.category === 'flight_refund' ||
                this.model.category === 'flight_change' ||
                this.model.category === 'changes' ||
                this.model.category === 'add_services'
            ) {
                if (this.model.clarification) {
                    if (!(<any>this).$v.model.orderNumber.$invalid) {
                        setTimeout(() => {
                            this.checkReservationByOrderNumber();
                        }, 500)
                    }
                }
            } else {
                if (!(<any>this).$v.model.orderNumber.$invalid) {

                    setTimeout(() => {
                        this.checkReservationByOrderNumber();
                    }, 500)
                }
            }
        }
    }

    onExchangeDesiredDateChange() {
        if ((<any>this).$v.model.exchangeDesiredDate.$error) {
            (<any>this).$v.model.exchangeDesiredDate.$touch();
            this.validateOrderNumber();
        }
        if (this.model.exchangeDesiredDate?.length === 0) {
            (<any>this).$v.model.exchangeDesiredDate.$reset();
        }
    }

    onDepartureDateChange() {
        if ((<any>this).$v.model.departureDate.$error) {
            (<any>this).$v.model.departureDate.$touch();
            this.validateDepartureDate();
        }
        if (this.model.departureDate?.length === 0) {
            (<any>this).$v.model.departureDate.$reset();
        }
    }

    checkReservationByOrderNumber() {
        let orderNumber = this.model.orderNumber;
        // @TODO move to better place
        this.checkedOrderNumber = orderNumber;
        new api.SupportService().getReservationData(orderNumber).then(
            (result: any) => {
                this.reservationData = result;
                this.cachedReservationData = result;
            },
            (error) => {
                this.reservationData = null;
                this.updateAlgorytmsResults();
                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }
            }
        );
    }

    checkVisibleAutovoid() {
        if (this.autovoidTimeout) {
            clearTimeout(this.autovoidTimeout);
        }

        if (this.model.category === 'cancel_same_day' && this.model.orderNumber.length >= 7) {
            this.autovoidTimeout = window.setTimeout(() => {
                this.$auth.checkVoidAvailability(this.model.orderNumber).then(({isAutoVoidAvailable}) => {
                    this.isVisibleAutovoid = isAutoVoidAvailable;
                });
            }, 300);
        } else {
            this.isVisibleAutovoid = false;
        }
    }

    formatFileSize(number: number) {
        if (number < 1024) {
            return number + ' b';
        } else if (number > 1024 && number < 1048576) {
            return (number / 1024).toFixed(1) + ' Kb';
        } else if (number > 1048576) {
            return (number / 1048576).toFixed(1) + ' Mb';
        }
    }

    onOrderNumberBlur() {
        if (
            this.model.orderNumber.length > 0 &&
            !(<any>this).$v.model?.orderNumber.validateOrderNumber
        ) {
            (<any>this).$v.model?.orderNumber.$touch();
            this.validateOrderNumber();
        }
    }

    onOrderNumberFocus() {
        (<any>this).$v.model.orderNumber.$reset();
    }

    onEmailBlur() {
        if (
            this.model.email.length > 0 &&
            !(<any>this).$v.model?.email.email
        ) {
            (<any>this).$v.model?.email.$touch();
            this.validateEmail();
        }
    }

    onEmailFocus() {
        (<any>this).$v.model.email.$reset();
    }

    onExchangeDesiredDateBlur() {
        if (
            this.model.exchangeDesiredDate !== null &&
            this.model.exchangeDesiredDate.length > 0
        ) {
            if (
                !(<any>this).$v.model?.exchangeDesiredDate.validateDayMonthExchangeDesiredDate ||
                !(<any>this).$v.model?.exchangeDesiredDate.validateYearExchangeDesiredDate

            ) {
                (<any>this).$v.model?.exchangeDesiredDate.$touch();
                this.validateExchangeDesiredDate();
            }
        }
    }

    onDepartureDateBlur() {
        if (
            this.model.departureDate !== null &&
            this.model.departureDate.length > 0
        ) {
            if (
                !(<any>this).$v.model?.departureDate.validateDayMonthDepartureDate ||
                !(<any>this).$v.model?.departureDate.validateYearDepartureDate

            ) {
                (<any>this).$v.model?.departureDate.$touch();
                this.validateDepartureDate();
            }
        }
    }

    onExchangeDesiredDateFocus() {
        (<any>this).$v.model.exchangeDesiredDate.$reset();
    }

    onDepartureDateFocus() {
        (<any>this).$v.model.departureDate.$reset();
    }

    onDescriptionFocus() {
        (<any>this).$v.model.description.$reset();
    }

    resetValidations() {
        this.$v.$reset();
    }

    validateOrderNumber() {
        if (!(<any>this).$v.model.orderNumber.customRequiredOrderNumber) {
            this.model.orderNumberErrorMessage = i18next.t('label_support_category_error_custom_require_order_number');
        } else if (!(<any>this).$v.model.orderNumber.validateOrderNumber) {
            this.model.orderNumberErrorMessage = i18next.t('label_support_category_error_validation_order_number');
        }
    }

    validateEmail() {
        if (!(<any>this).$v.model.email.required) {
            this.model.emailErrorMessage = i18next.t('label_support_category_error_custom_required');
        } else if (!(<any>this).$v.model.email.email) {
            this.model.emailErrorMessage = i18next.t('label_support_category_error_email');
        }
    }

    validateDepartureDate() {
        if (!(<any>this).$v.model.departureDate.customMaxLengthDepartureDate) {
            this.model.departureDateErrorMessage = i18next.t('label_support_category_error_require_departure_data');
        } else if (!(<any>this).$v.model.departureDate.validateDayMonthDepartureDate) {
            this.model.departureDateErrorMessage = i18next.t('label_support_category_error_month_day_exchange_data');
        } else if (!(<any>this).$v.model.departureDate.validateYearDepartureDate) {
            this.model.departureDateErrorMessage = i18next.t('label_support_category_error_year_exchange_data');
        }
    }

    validateExchangeDesiredDate() {
        if (
            !(<any>this).$v.model.exchangeDesiredDate.customRequiredExchangeDesiredDate ||
            !(<any>this).$v.model.exchangeDesiredDate.customMaxLengthExchangeDesiredDate
        ) {
            this.model.exchangeDesiredDateErrorMessage = i18next.t('label_support_category_error_require_exchange_data');
        } else if (!(<any>this).$v.model.exchangeDesiredDate.validateDayMonthExchangeDesiredDate) {
            this.model.exchangeDesiredDateErrorMessage = i18next.t('label_support_category_error_month_day_exchange_data');
        } else if (!(<any>this).$v.model.exchangeDesiredDate.validateYearExchangeDesiredDate) {
            this.model.exchangeDesiredDateErrorMessage = i18next.t('label_support_category_error_year_exchange_data');
        }
    }

    validateDescription() {
        if (!(<any>this).$v.model.description.required) {
            this.model.descriptionErrorMessage = i18next.t('label_support_category_error_require_description');
        }
    }

    checkErrors() {
        this.$v.model!.$touch();

        this.validateOrderNumber();
        this.validateEmail();
        this.validateExchangeDesiredDate();
        this.validateDescription();
        this.validateDepartureDate();
    }

    submitTicket() {
        (<any>this.$refs).dialog.isActive = false;
        // Use form data for file upload
        const request = new FormData();

        request.append('category', <string>this.model.category);
        request.append('description', <string>this.model.description);
        request.append('email', <string>this.model.email);
        request.append('orderNumber', this.model.orderNumber);
        request.append('clientDevice', JSON.stringify(G2S.config.clientDevice));
        request.append('ticketForm', 'new');

        if (this.model.subCategory) {
            request.append('subCategory', <string>this.model.subCategory);
        }

        if (this.model.category == 'flight_change' && G2S.config.marketCode == 'ru') {
            request.append('exchangeDesiredDate', <string>this.model.exchangeDesiredDate);
        }

        if (this.model.category === 'itinerary' && this.model.departureDate?.length !== 0) {
            request.append('departureDate', <string>this.model.departureDate);
        }

        if (this.model.clarification) {
            request.append('requestClarification', <string>this.model.clarification);
            if (this.model.category === 'add_services' && this.model.flightServices?.length) {
                let services = this.model.flightServices
                    .filter(option => option.isSelected) // Фильтрация объектов с isSelected === true
                    .map(option => option.internalName);   // Извлечение полей russianName
                request.append('flightServices', <any>services);
            }
        }

        for (let i = 0; i < this.selectedFiles.length; i++) {
            request.append('files[' + i + ']', this.selectedFiles[i]);
        }

        this.model.submitted = true;

        let dataСompleted: any = {};
        dataСompleted = {
            email: this.model.email || undefined,
            num_order: this.model.orderNumber || undefined,
            departure_date: this.model.departureDate || undefined,
            change: this.activeClarificationChangeInfoOption || undefined,
            description: this.model.description || undefined,
            reason: this.activeClarificationRefundOptionsOption || undefined,
            subtopic: this.activeClarificationAdditionalServiceOption || undefined,
            topic: this.activeCategoryOption || undefined,
            with_attachment: this.selectedFiles.length || undefined,
        };

        new api.SupportService().create(request).then(
            (result: api.SupportCreateResult) => {
                this.model.submitted = false;

                
                if (result.success) {
                    this.sendAviasalesAnalyticsEvent({
                        label: 'ota_feedback_form',
                        action: 'applied',
                        data_completed: dataСompleted,
                    });
                    (<any>this.$root).$refs.dialogMessage.show({
                        persistent: true,
                        titlePosition: 'center',
                        title: i18next.t('title_received_your_request'),
                        text: i18next.t('label_support_request_success_getting_ready'),
                        btnOkLabel: i18next.t('button_will_wait'),
                        btnOkHandler: () => {
                            window.location.href = G2S.config.theme !== 'aviasales' ? '/' : 'https://aviasales.ru';
                        }
                    });
                    (<any>this).$ga.sendEvent('support.new', 'submit.success', 'support.new.submit.success');
                    (<any>this).$ga.reachGoal('support.new.success');
                } else {
                    (<any>this).$ga.sendEvent('support.new', 'error', 'support.new.error');
                    (<any>this).$ga.reachGoal('support.new.error.server');
                    // (<any>this.$root).$refs.dialogMessage.show({
                    //     title: i18next.t('error'),
                    //     text: result.message
                    // });
                }
            },
            (error) => {
                this.model.submitted = false;
                (<any>this).$ga.sendEvent('support.new', 'error', 'support.new.server.error');
                (<any>this).$ga.reachGoal('support.new.error.server');

                if (error.response) {
                    console.log('XHR failed', error.response.status, error.response.data);
                } else {
                    console.log('XHR error', error.message);
                }

                let errorMessage = i18next.t('error_server_tryagain');

                if (error?.response?.data?.localizedMessage) {
                    errorMessage = error.response.data.localizedMessage;
                }

                this.sendAviasalesAnalyticsEvent({
                    label: 'ota_feedback_form_error',
                    action: 'showed',
                    error_type: errorMessage,
                });

                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('error_cant_find_order'),
                    text: errorMessage,
                    btnOkLabel: i18next.t('button_ok_will_check'),
                });
            }
        );
    }

    onFilesAdd() {
        (<any>this.$refs).files.click();
    }

    onFilesClear() {
        (<any>this.$refs).files.value = '';
        this.selectedFiles = [];
    }

    onCategoryChange(val: string) {
        if (val == 'flight_refund') {
            (<any>this).$ga.sendEvent('refund.tickets', 'select.topic', 'refund.tickets.select.topic.support.new', this.gaParams);
        }

        if (!this.categoryWasSelected) {
            for (let i = this.categoryOptions.length - 1; i >= 0; i--) {
                if (this.categoryOptions[i].value === null) {
                    this.categoryOptions.splice(i, 1);
                }
            }
        }

        this.categoryWasSelected = true;
        this.model.clarification = '';
        this.loadSubCategories();

        // this.reservationData = null;
        // this.refundAlgorytmResult = null;
        // this.changeAlgorytmResult = null;
        // this.cancelAlgorytmResult = null;
        // this.additionalSertviceAlgorytmResult = null;

        this.checkVisibleAutovoid();
        if (
            this.model.orderNumber.length !== this.model.maxOrderNumberLegth ||
            this.model.orderNumber == this.checkedOrderNumber
        ) {
            return;
        }
        this.resetValidations();
        this.tryCheckReservationByOrderNumber();
        // this.resetForm();
    }

    onFilesChange() {
        this.selectedFiles = (<any>this.$refs).files.files;
    }

    onSubmit() {
        (<any>this).$ga.sendEvent('support.new', 'btn.submit', 'support.new.btn.submit');
        (<any>this).$ga.reachGoal('support.new.submit');

        const dataPrecompleted = {
            email: this.model.email || undefined,
            num_order: this.model.orderNumber || undefined,
            departure_date: this.model.departureDate || undefined,
            change: this.activeClarificationChangeInfoOption || undefined,
            description: this.model.description || undefined,
            reason: this.activeClarificationRefundOptionsOption || undefined,
            subtopic: this.activeClarificationAdditionalServiceOption || undefined,
            topic: this.activeCategoryOption || undefined,
            with_attachment: this.selectedFiles.length || undefined,
        };
        this.sendAviasalesAnalyticsEvent({
            label: 'ota_feedback_form',
            action: 'clicked',
            data_completed: dataPrecompleted,
        });
        this.checkErrors();

        if (this.$v.$error) {
            // (<any>this.$root).$refs.dialogMessage.show({
            //     title: i18next.t('error'),
            //     text: this.model.error
            // });
            window.scrollTo(0, 100);
            (<any>this).$ga.sendEvent('support.new', 'error', 'support.new.error');
            (<any>this).$ga.reachGoal('support.new.error');

            const errors = [
                (<any>this).$v.model.orderNumber.$error ? this.model.orderNumberErrorMessage : '',
                (<any>this).$v.model.email.$error ? this.model.emailErrorMessage : '',
                (<any>this).$v.model.exchangeDesiredDate.$error ? this.model.exchangeDesiredDateErrorMessage : '',
                (<any>this).$v.model.departureDate.$error ? this.model.departureDateErrorMessage : '',
                (<any>this).$v.model.description.$error ? this.model.descriptionErrorMessage : '',
            ].filter(errorMessage => errorMessage);

            this.sendAviasalesAnalyticsEvent({
                label: 'ota_feedback_form_error',
                action: 'showed',
                error_type: errors,
            });

            return;
        }

        if (this.isVisibleAutovoid) {
            this.model.submitted = true;

            const getRefundInfo = () => {
                this.$auth.getRefundInfoWithWriteUs(G2S.config.locale, this.model.orderNumber).then(
                    (result) => {
                        this.model.submitted = false;
                        this.refundInfo = <api.RefundInfo>result;
                        (<any>this.$refs).dialog.isActive = true;
                    },
                    (error) => this.submitTicket()
                );
            };

            if (this.$auth.currentUser) {
                this.$auth.ordersExists(this.model.orderNumber).then(
                    (result) => {
                        if (result.orderExists) {
                            getRefundInfo();
                        } else {
                            this.submitTicket();
                        }
                    },
                    (error) => this.submitTicket()
                );
            } else {
                new api.SupportService().checkReservationEmail(this.model.orderNumber, this.model.email).then(
                    (result) => {
                        if (result.isSameEmail) {
                            getRefundInfo();
                        } else {
                            this.submitTicket();
                        }
                    },
                    (error) => this.submitTicket()
                );
            }
        } else {
            this.submitTicket();
        }
    }

    onEmailChange() {
        if ((<any>this).$v.model.email.$error) {
            (<any>this).$v.model.email.$touch();
            this.validateEmail();
        }
        if (this.model.email.length === 0) {
            (<any>this).$v.model.email.$reset();
        }
        this.model.email = utils.String.disabledCyrillic(
            this.model.email,
            () => {
                this.showTooltip(
                    (<any>this.$refs).email.$el,
                    i18next.t('error_letters_latin_numbers_symbols_dashes_underscores_only')
                );
            },
        );

        (<any>this.$refs).email.lazyValue = this.model.email;
    }

    onDescriptionChange() {
        if (this.model.description?.length === 0) {
            (<any>this).$v.model.description.$reset();
        }
    }

    onClose() {
        (<any>this.$refs).dialog.isActive = false;
    }

    onAcceptCancelingOrder() {
        this.$auth.createVoidSupport(this.model.orderNumber, this.model.email, this.model.description).then(
            () => {
                this.$auth.getProcessStartedText(G2S.config.locale).then(
                    (result) => {
                        (<any>this.$refs).dialog.isActive = false;
                        (<any>this.$root).$refs.dialogMessage.show({
                            title: result.headerText,
                            text: result.messageText,
                            btnOkLabel: result.buttonAcceptText,
                            btnOkHandler: () => {
                                router.push('/');
                            }
                        });
                    },
                    (error) => {
                        (<any>this.$refs).dialog.isActive = false;
                        (<any>this.$root).$refs.dialogMessage.show({
                            title: i18next.t('error'),
                            text: (error.response.data && error.response.data.localizedMessage) ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                        });
                    }
                );
            },
            (error) => {
                (<any>this.$refs).dialog.isActive = false;
                (<any>this.$root).$refs.dialogMessage.show({
                    title: i18next.t('error'),
                    text: (error.response.data && error.response.data.localizedMessage) ? error.response.data.localizedMessage : i18next.t('error_server_tryagain')
                });
            }
        );
    }

    showTooltip(target, text) {
        (<any>this).$refs.tooltip.isActive = false;

        if (this.tooltipTimeout) {
            clearTimeout(this.tooltipTimeout);
        }

        this.$nextTick(() => {
            this.tooltipText = text;
            this.tooltipActivator = target;
            (<any>this).$refs.tooltip.isActive = true;

            this.tooltipTimeout = window.setTimeout(() => {
                (<any>this).$refs.tooltip.isActive = false;
            }, 2000);
        });
    }
}
